import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { zodI18nMap } from "zod-i18n-map";
import { z } from "zod";
import { i18nConfig } from "@/config";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { initAnalytics } from "@/utils/hooks/analytics.hooks";

Sentry.init({
  dsn: "https://098cc663a417f8cfd420b487790807e9@o4506947460726784.ingest.us.sentry.io/4506947465117696",
  release: __APP_VERSION__,
  environment: window.envData.env,
  enabled: !__IS_LOCAL__,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.replayIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 0.05,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: window.envData.env === "prd" ? 1.0 : 0,
});

i18next
  .use(HttpBackend)
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    detection: { caches: ["localStorage"] },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    supportedLngs: i18nConfig.locales,
    ns: ["common", "zod"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
  });
z.setErrorMap(zodI18nMap);

initAnalytics(__APP_VERSION__);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
